import { FormGroup } from '@material-ui/core'
import AutoSizer from 'react-virtualized-auto-sizer'
import { FixedSizeList } from 'react-window'

import { FieldInfo } from '@/pages/maps/contexts/region-context'

import { useFieldCentralization } from '../../../hooks/use-field-centralization'
import FieldListRow from './list-row'

interface FieldsListProps {
  items: (FieldInfo & { checked: boolean })[]
  onToggle?: (id: string) => void
}

export function FieldsList({ items, onToggle }: FieldsListProps) {
  const onGoToField = useFieldCentralization()

  return (
    <AutoSizer>
      {({ height, width }) => (
        <FixedSizeList
          height={height - 18}
          width={width}
          itemSize={38}
          itemCount={items.length}
          itemData={{ items, onToggle, onGoToField }}
          outerElementType={FormGroup}
          overscanCount={6}
        >
          {FieldListRow}
        </FixedSizeList>
      )}
    </AutoSizer>
  )
}
